import Vue from 'vue'
import Slider from 'vue-slider-component'
import InfiniteLoading from 'vue-infinite-loading'
import { Modal, Collapse, Popover, Dropdown } from 'uiv'
import Vue2Leaflet from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import { VueTabs, VTab } from 'vue-nav-tabs'
import Typeahead from 'vue2-typeahead'
import 'vue-nav-tabs/themes/vue-tabs.css'
import Select from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { directive as onClickaway } from 'vue-clickaway'

Vue.component('USlider', Slider)
Vue.component('UInfiniteLoading', InfiniteLoading)
Vue.component('UModal', Modal)
Vue.component('UCollapse', Collapse)
Vue.component('UTabs', VueTabs)
Vue.component('UTab', VTab)
Vue.component('UTypeahead', Typeahead)
Vue.component('UDropdown', Dropdown)
Vue.component('USelect', Select)
Vue.component('UClickaway', onClickaway)

Vue.component('UPopover', $.extend(true, Popover, {
  mixins: [{
    props: {
      targetClass: {
        type: String,
        required: false
      }
    }
  }]
}))

// add extra class to override css
var _resetPosition = Popover.mixins[0].methods.resetPosition

Popover.mixins[0].methods.resetPosition = function () {
  if (this.targetClass) {
    var $popup = $(this.$refs.popup)
    $popup.addClass(this.targetClass)
  }

  _resetPosition.call(this)
}

Vue.component('LMap', Vue2Leaflet.Map)
Vue.component('LPopup', Vue2Leaflet.Popup)
Vue.component('LMarker', Vue2Leaflet.Marker)
Vue.component('LTileLayer', Vue2Leaflet.TileLayer)
Vue.component('LMarkerCluster', Vue2LeafletMarkerCluster)

Vue.component('VForm', require('./form/Form').default)
Vue.component('VGoTop', require('./go-top/GoTop').default)
Vue.component('VModal', require('./modal/Modal').default)
Vue.component('VCollapse', require('./collapse/Collapse').default)
Vue.component('VDropdownBox', require('./dropdown-box/DropdownBox').default)
Vue.component('VDropdownSelect', require('./dropdown-box/DropdownSelect').default)
Vue.component('VPopover', require('./popover/Popover').default)



// WEBPACK FOOTER //
// ./src/components/index.js